/** Maskanlar sahifalarining qatlam ranglari.
 *  `SURFACE` — sahifa foni ustidagi karta (--card ning shaffof bo'lmagan varianti),
 *  `SURFACE_RAISED` — CustomCard ichida CustomCard turganda hosil bo'ladigan rang. */
export const SURFACE = 'bg-[#1F1C2B]';
export const SURFACE_RAISED = 'bg-[#2C2740]';

/** Qiymat ranglari — maketdagi kabi. */
export const VALUE_COLORS = {
  green: 'text-[#66DC7E]',
  amber: 'text-[#F5BD1E]',
  violet: 'text-[#A185FD]',
} as const;

/** Leaflet CSS klass emas, haqiqiy rang qiymatini kutadi. */
export const MAP_MARKER_COLOR = '#66DC7E';
/** Tanlanmagan markerlar — ko'rinadi, lekin e'tiborni tortmaydi. */
export const MAP_MARKER_COLOR_MUTED = '#4A7C63';

/** Respublika/viloyat kesimidagi progress barlar: qabul qilingan / shartnoma rejasi. */
export const CONTRACT_LOADS = [
  {
    labelKey: 'futures_contract_by',
    netKey: 'futures_physical_net',
    planKey: 'futures_contract_plan',
    barColor: 'bg-[#F5821F]',
  },
  {
    labelKey: 'forward_contract_by',
    netKey: 'forward_physical_net',
    planKey: 'forward_contract_plan',
    barColor: 'bg-[#7ED321]',
  },
  {
    labelKey: 'storage_contract_by',
    netKey: 'storage_physical_net',
    planKey: 'storage_contract_plan',
    barColor: 'bg-[#22B8E0]',
  },
] as const;

/** Klaster ichida ko'rsatiladigan shartnoma turlari. */
export const CONTRACT_TYPES = [
  { labelKey: 'forward', key: 'forward' },
  { labelKey: 'futures', key: 'futures' },
  { labelKey: 'storage', key: 'storage' },
] as const;

/** Diagramma qatorlari ranglari — yuqoridan pastga, ochiqdan to'qqa.
 *  Qatorlar soni palitradan ko'p bo'lsa oxirgi rang takrorlanadi. */
export const CHART_ROW_COLORS = {
  violet: [
    '#B255FF',
    '#A436FF',
    '#971AFF',
    '#8B00FF',
    '#7D00E6',
    '#7100CF',
    '#6600BA',
    '#5C00A7',
    '#530096',
  ],
  blue: [
    '#5589FF',
    '#3674FF',
    '#1A61FF',
    '#004FFF',
    '#0047E6',
    '#0040CF',
    '#003ABA',
    '#0034A7',
    '#002F96',
  ],
};
